import {Component} from 'vue-property-decorator'
import LoginForm from '@/LoginForm.vue'
import WelcomeCarousel from './Welcome.vue'
import ConfirmDialog from '@/ConfirmDialog.vue'
import _ from 'lodash';
import CopyableLink from './CopyableLink.vue'
import HomeWatches from './HomeWatches';
import { inCurrentDistanceUnits } from './Filters';
import { Splitpanes, Pane } from 'splitpanes'

@Component({
    components: {
        LoginForm,
        WelcomeCarousel,
        ConfirmDialog,
        CopyableLink,
        Splitpanes,
        Pane
    },
    filters: {
        inCurrentDistanceUnits
    }
})
export default class Home extends HomeWatches {    
    async mounted() {
        await super.mounted()
    }
}
